/**
 * /operations/travel-agent — Business Travel agent (Pack 11 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function BusinessTravelAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Business Travel Agent"
        subtitle="Tashghil drives travel requests + approvals + bookings; Rawatib handles expense disbursement."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil</h3></div>
        <p className="text-sm text-text-secondary">Approval routing per grade-tier cabin class. Hotel + per-diem policy enforcement. Booking workflow.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="rawatib" /><h3 className="text-base font-semibold">Rawatib</h3></div>
        <p className="text-sm text-text-secondary">Expense claim disbursement integrated into the next payroll period.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="khidmat" /><h3 className="text-base font-semibold">Khidmat</h3></div>
        <p className="text-sm text-text-secondary">Employee travel request intake via WhatsApp / chat.</p>
      </section>
    </div>
  );
}
